<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" @click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <UserInfo/>
        <div class="profile-btn-grid">
            <router-link to="/configurator_lite/projects" target="_blank"
                         class="modal-button modal-button-auto-width profile-btn hide-underline"
                         v-bind:class="{'width-140': !APAvailable}"
            >
                Lite Версия
            </router-link>
            <router-link v-show="APAvailable" to="/admin/products" target="_blank" class="modal-button modal-button-auto-width profile-btn hide-underline">
                Панель администратора
            </router-link>
        </div>
        <div class="profile-btn-grid">
            <div class="modal-button modal-button-auto-width button-logout hide-underline" @click="logOut">
                Выйти из профиля
            </div>
        </div>
    </div>
</template>

<script>
    import SVGModalClose from "../SVG/SVGModalClose";
    import {modalMethods} from "../common";
    import UserInfo from "./UserInfo";

    export default {
        name: "ModalProfile",
        components: {
            UserInfo,
            SVGModalClose
        },
        computed: {
            APAvailable() {
                console.log(this.$store.state.profile.userRole)
                return this.$store.state.profile.userRole === 'superadmin'
            }
        },
        methods:{
            logOut(){
                localStorage.token = '';
                this.$store.commit('profile/USER_AUTHORIZED', false);
                this.$router.push({name: 'liteProjects'}).catch(() => {});
            }
        }
    }
</script>

<style scoped>
    .width-140 {
        width: 140px;
    }
</style>
